/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import {
  AiDisclaimerRequestDto,
  AiDisclaimerResponseDto,
  DirectDisclaimerResponseDto,
  DisclaimerTargetResponse,
  DisclaimerTextResponseDto,
  GetDisclaimerRequest,
  ShortUrlEntity,
  ShortUrlRequest,
  TenantLite
} from '@/store/models';
import axios from 'axios';

export const pitchYouDataAPi = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URI
  });
  
export async function applyDisclaimerServer(
    request: ShortUrlRequest
  ): Promise<DisclaimerTargetResponse> {
    return new Promise((resolve, reject) => {
      pitchYouDataAPi
        .post('/api/shorturl/v1/applydisclaimer', request)
        .then((response) => {
          resolve(response.data as DisclaimerTargetResponse);
        })
        .catch((error) => {
          if (error && error.response) {
            console.log(error.response);
          }
          reject(new Error('APPLY_DISCLAIMER_FAILED'));
        });
    });
}

export async function fetchTenantInfoLiteServer(
    languageCode?: string
  ): Promise<TenantLite> {
    return new Promise((resolve, reject) => {
      pitchYouDataAPi
        .get('/api/tenant/v1-tenant-lite', {
          params: { languageCode: languageCode }
        })
        .then(response => {
          resolve(response.data as TenantLite);
        })
        .catch(error => {
          if (error && error.response) {
            console.log(error.response);
          }
          reject(new Error('INVALID_TENANT'));
        });
    });
  }


export async function applyAiDisclaimerServer(
  request: AiDisclaimerRequestDto
): Promise<AiDisclaimerResponseDto> {
  return new Promise((resolve, reject) => {
    pitchYouDataAPi
      .post('/api/shorturl/v1/apply-ai-disclaimer', request)
      .then(response => {
        resolve(response.data as AiDisclaimerResponseDto);
      })
      .catch(error => {
        if (error && error.response) {
          console.log(error.response);
        }
        reject(new Error('ACCEPT_AI_DISCLAIMER_FAILED'));
      });
  });
}

export async function getDisclaimerTargetServer(
  request: ShortUrlRequest
): Promise<DisclaimerTargetResponse> {
  return new Promise((resolve, reject) => {
    pitchYouDataAPi
      .post('/api/shorturl/v1/directdisclaimer', request)
      .then(response => {
        resolve(response.data as DisclaimerTargetResponse);
      })
      .catch(error => {
        if (error && error.response) {
          console.log(error.response);
        }
        reject(new Error('GET_DISCLAIMER_TARGET_FAILED'));
      });
  });
}

export async function isDirectDisclaimerServer(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    pitchYouDataAPi
      .get('/api/shorturl/v1/directdisclaimer')
      .then(response => {
        resolve(response.data as boolean);
      })
      .catch(error => {
        if (error && error.response) {
          console.log(error.response);
        }
        reject(new Error('IS_DIRECT_DISCLAIMER_FAILED'));
      });
  });
}

export async function isDirectDisclaimerForGuidServer(
  guid: string
): Promise<DirectDisclaimerResponseDto> {
  return new Promise((resolve, reject) => {
    pitchYouDataAPi
      .get('/api/shorturl/v1/directdisclaimer/' + guid)
      .then(response => {
        resolve(response.data as DirectDisclaimerResponseDto);
      })
      .catch(error => {
        if (error && error.response) {
          console.log(error.response);
        }
        reject(new Error('IS_DIRECT_DISCLAIMER_FAILED'));
      });
  });
}

export async function getShortUrlTargetServer(
  request: ShortUrlRequest
): Promise<ShortUrlEntity> {
  return new Promise((resolve, reject) => {
    pitchYouDataAPi
      .post('/api/shorturl/v1', request)
      .then(response => {
        resolve(response.data as ShortUrlEntity);
      })
      .catch(error => {
        if (error && error.response) {
          console.log(error.response);
        }
        reject(new Error('GET_SHORTURL_TARGET_FAILED'));
      });
  });
}

export async function getDisclaimerTextInfoServer(
  request: GetDisclaimerRequest
): Promise<DisclaimerTextResponseDto> {
const url = `/api/disclaimer/${request.language}`;
  const params: any = {};
  if (request.disclaimerType) params.disclaimerType = request.disclaimerType;
  const res = await pitchYouDataAPi.get(url, { params });
  return res.data as DisclaimerTextResponseDto;
}

export function apiPath(path: string) {
  return path.startsWith('/') ? path : '/' + path;
}


export async function validateSalesTokenServer(
  salesToken: string
): Promise<boolean> {
  return new Promise((resolve, reject) => {
    pitchYouDataAPi
      .get('/api/privacy/v1/salestoken', { params: { salesToken: salesToken } })
      .then(response => {
        resolve(response.data as boolean);
      })
      .catch(error => {
        if (error && error.response) {
          console.log(error.response);
        }
        reject(new Error('VALIDATE_SALES_TOKEN_FAILED'));
      });
  });
}